<script>
  import { createEventDispatcher } from 'svelte';
  import Modal from '@components/Modal.svelte';
  import Input from '@components/Input.svelte';
  import BootstrapDropdown from '@utils/bootstrap-dropdown';
  import Notification from '@utils/notification';

  const dispatch = createEventDispatcher();

  export let showModal = false;
  export let mobile = false;

  let name;
  let listing_flag = 'listed';

  let showPublicHiddenDropdown = false;

  var close = function () {
    dispatch('close');

    showModal = false;
    name = '';
    listing_flag = 'listed';
    showPublicHiddenDropdown = false;
  };

  let updateListingFlag = function (flag) {
    listing_flag = flag;
  };

  let submitOnEnter = function (e) {
    if (e.detail.which == 13) {
      saveGroup();
    }
  };

  let saveGroup = function () {
    if (name === '') {
      Notification.send({
        text: "List name can't be blank",
      });

      return;
    }

    dispatch('create-group', {
      name: name,
      listing_flag: listing_flag,
      auto_set_emoji: true,
    });
    close();
  };
</script>

<style style="text/scss" lang="scss">
  .ui-header {
    font-weight: bold;
    font-size: 12px;
    line-height: 15px;
    text-align: center;
    text-transform: uppercase;
    color: #1a1a1a;
    margin-top: -50px;
  }

  .form-input-group {
    margin-bottom: 16px;
  }

  .add-section-link {
    font-size: 15px;
    opacity: 0.5;
    font-weight: 500;
    line-height: 15px;
    color: #000;

    &:hover {
      opacity: 1;
    }
  }

  label {
    font-size: 13px;
    line-height: 15px;
    opacity: 0.5;
    margin-bottom: 12px;
    font-weight: normal;
  }

  .ui-actions {
    margin-top: 25px;
    max-width: 275px;
    margin-left: auto;
    margin-right: auto;

    .add-group-btn {
      height: 48px;
      color: white;
      font-weight: 500;
      font-size: 14px;
      border: none;
      border-radius: 15px;
      background: #a893f9;
      width: 275px;

      &:hover {
        background: #7054dc;
      }
    }

    .cancel-btn {
      width: 100%;
      color: #000;
      font-size: 15px;
      margin-top: 12px;
      font-weight: 500;
      border: none;
      background: transparent;
    }
  }

  .public-hidden-dropdown {
    display: flex;
    align-items: center;

    .public-hidden-btn {
      cursor: pointer;
      width: 60px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 2px solid #ececec;
      border-radius: 20px;

      .eye-icon {
        margin-right: 6px;
      }
    }

    .dropdown-menu {
      position: absolute;
      top: 35px;
      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.1);
      border: 0px;
      border-radius: 12px;
      overflow: hidden;
      padding-top: 12px;
      padding-bottom: 12px;

      a {
        font-size: 14px;
        line-height: 20px;
        padding-top: 4px;
        padding-bottom: 4px;

        &.selected-item {
          font-weight: 500;

          .fa {
            visibility: visible;
          }
        }

        .fa {
          margin-right: 12px;
          color: #a893f9;
          visibility: hidden;
        }

        &:hover {
          background-color: white;
          color: #a893f9;
        }
      }
    }
  }
</style>

<Modal
  mobile={mobile}
  on:close={close}
  show={showModal}
  showCloseButton={true}
  fadeInDuration={200}
  style="border-radius: 16px; width: 490px">
  <div slot="content" on:click={() => (showPublicHiddenDropdown = false)}>
    <div class="ui-header">NAME YOUR LIST</div>

    <div
      style="margin-top: 40px; width: 275px; margin-left: auto; margin-right:
      auto;">
      <Input
        focus={true}
        bind:value={name}
        labelStyle="font-size: 15px"
        inputStyle="font-size: 17px; font-weight: normal"
        placeholder="List name"
        on:keyup={submitOnEnter} />
    </div>

    <div
      style="display: flex; margin-top: 20px; padding-left: 20px; padding-right: 20px; margin-bottom: 40px; width: 320px; margin-left: auto; margin-right: auto;">
      <div class="public-hidden-dropdown dropdown" use:BootstrapDropdown.setup>
        <span data-bs-toggle="dropdown">
          <div
            on:click|stopPropagation={() => (showPublicHiddenDropdown = !showPublicHiddenDropdown)}
            class="public-hidden-btn">
            <img
              src="/images/share-modal/hidden.svg"
              class="eye-icon"
              style={listing_flag === 'unlisted' ? '' : 'display: none'} />

            <img
              src="/images/share-modal/visible.svg"
              class="eye-icon"
              style={listing_flag === 'listed' ? '' : 'display: none'} />

            <img
              src="/images/share-modal/down.svg"
              class="down-arrow"
              style={showPublicHiddenDropdown ? 'transform: rotate(180deg);' : ''} />
          </div>
        </span>
        <ul class="dropdown-menu {showPublicHiddenDropdown ? 'show' : ''}">
          <li>
            <a
              href="#"
              on:click|preventDefault={() => updateListingFlag('unlisted')}
              class:selected-item={listing_flag == 'unlisted'}>
              <span class="fa fa-check" />
              <span>Hidden list</span>
            </a>

            <a
              href="#"
              on:click|preventDefault={() => updateListingFlag('listed')}
              class:selected-item={listing_flag == 'listed'}>
              <span class="fa fa-check" />
              <span>Public list</span>
            </a>
          </li>
        </ul>
      </div>

      <div style="margin-left: 24px;">
        {#if listing_flag == 'listed'}
          <div style="font-weight: 500; font-size: 14px; line-height: 20px;">Public list</div>
          <div style="font-size: 14px; line-height: 20px; margin-top: 5px; color: #7F7F7F;">
            Publicly visible on profile
          </div>
        {:else}
          <div style="font-weight: 500; font-size: 14px; line-height: 20px;">Hidden list</div>
          <div style="font-size: 14px; line-height: 20px; margin-top: 5px; color: #7F7F7F;">
            Not publicly visible on profile
          </div>
        {/if}
      </div>
    </div>

    <div class="ui-actions">
      <button class="add-group-btn" on:click|preventDefault={saveGroup}> Create list </button>
    </div>
  </div>
</Modal>
